<template>
  <b-form class="grc-form" @submit.prevent="submitForm">
    <b-alert
      v-if="localForm.secondLevelApprover && approvalLabel"
      show
      variant="info"
      class="grc-form__alert"
    >
      Aprovação: {{ approvalLabel }}
    </b-alert>

    <b-alert
      v-if="submitValidationError"
      show
      variant="warning"
      class="grc-form__alert py-2"
    >
      {{ submitValidationError }}
    </b-alert>

    <section class="grc-form__section">
      <div class="grc-form__section-header">
        <h3 class="grc-form__section-title">Identificação e definição</h3>
        <p class="grc-form__section-description">
          Defina o requisito, seu status atual e o contexto descritivo.
        </p>
      </div>

      <b-row>
        <b-col cols="12" md="8">
          <b-form-group
            label="Título do requisito *"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-input
              v-model.trim="localForm.title"
              class="grc-form-control"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            label="Status *"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-select
              v-model="localForm.status"
              :options="statusOptions"
              class="grc-form-control"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group
        label="Descrição do requisito"
        label-class="grc-form__label"
        class="grc-form__group"
      >
        <b-form-textarea
          v-model.trim="localForm.description"
          rows="3"
          class="grc-form-control"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group
        label="Obrigações derivadas"
        label-class="grc-form__label"
        class="grc-form__group"
      >
        <b-form-textarea
          v-model.trim="localForm.derivedObligations"
          rows="3"
          class="grc-form-control"
        ></b-form-textarea>
      </b-form-group>
    </section>

    <section class="grc-form__section">
      <div class="grc-form__section-header">
        <h3 class="grc-form__section-title">Origem e enquadramento</h3>
        <p class="grc-form__section-description">
          Organize a fonte, a jurisdição e a forma de aplicação do requisito.
        </p>
      </div>

      <b-row>
        <b-col cols="12" md="4">
          <b-form-group
            label="Tipo de fonte *"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-select
              v-model="localForm.sourceType"
              :options="sourceTypeOptions"
              class="grc-form-control"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            label="Fonte *"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-input
              v-model.trim="localForm.sourceName"
              class="grc-form-control"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            label="Identificador da fonte"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-input
              v-model.trim="localForm.sourceIdentifier"
              class="grc-form-control"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="6">
          <b-form-group
            label="Dispositivo"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-input
              v-model.trim="localForm.sourceDispositive"
              class="grc-form-control"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            label="Jurisdição"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-input
              v-model.trim="localForm.jurisdiction"
              :required="localForm.sourceType === 'legal-regulatory'"
              class="grc-form-control"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="4">
          <b-form-group
            label="Aplicabilidade *"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-select
              v-model="localForm.applicationType"
              :options="applicationTypeOptions"
              class="grc-form-control"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            label="Criticidade *"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-select
              v-model="localForm.criticality"
              :options="criticalityOptions"
              class="grc-form-control"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            label="Segregação"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-select
              v-model="localForm.segregation"
              :options="segregationOptions"
              class="grc-form-control"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group
        label="Detalhes da aplicabilidade"
        label-class="grc-form__label"
        class="grc-form__group"
      >
        <b-form-input
          v-model.trim="localForm.applicationDetails"
          class="grc-form-control"
        ></b-form-input>
      </b-form-group>
    </section>

    <section class="grc-form__section">
      <div class="grc-form__section-header">
        <h3 class="grc-form__section-title">Responsabilidade e vínculos</h3>
        <p class="grc-form__section-description">
          Conecte o requisito à estrutura organizacional e aos projetos
          relacionados.
        </p>
      </div>

      <b-row>
        <b-col cols="12" md="4">
          <b-form-group
            label="Núcleo/Categoria interna"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-input
              v-model.trim="localForm.internalCategory"
              class="grc-form-control"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            label="Área responsável *"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-select
              v-model="localForm.area"
              :options="areaOptions"
              class="grc-form-control"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            label="Escopo"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-select
              v-model="localForm.scope"
              :options="scopeOptionsWithEmpty"
              class="grc-form-control"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group
        label="Projetos vinculados"
        label-class="grc-form__label"
        class="grc-form__group"
      >
        <SearchableSelect
          v-model="localForm.projects"
          :options="projectOptions"
          multiple
          placeholder="Selecione um ou mais projetos"
          search-placeholder="Buscar projeto..."
          :use-company-filter="false"
          :control-class="'grc-form-control'"
        />
      </b-form-group>

      <b-row>
        <b-col cols="12" md="4">
          <b-form-group
            label="Dono/Responsável"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-select
              v-model="localForm.owner"
              :options="userOptionsWithEmpty"
              class="grc-form-control"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            label="Gestor/Pessoa"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-select
              v-model="localForm.manager"
              :options="userOptionsWithEmpty"
              class="grc-form-control"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            label="Aprovador de segundo nível"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-select
              v-model="localForm.secondLevelApprover"
              :options="userOptionsWithEmpty"
              class="grc-form-control"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </section>

    <section class="grc-form__section">
      <div class="grc-form__section-header">
        <h3 class="grc-form__section-title">Acompanhamento e revisão</h3>
        <p class="grc-form__section-description">
          Mantenha os critérios, datas-chave e o ciclo de revisão do requisito.
        </p>
      </div>

      <b-form-group
        label="Critérios de cumprimento"
        label-class="grc-form__label"
        class="grc-form__group"
      >
        <b-form-textarea
          v-model.trim="localForm.complianceCriteria"
          rows="3"
          class="grc-form-control"
        ></b-form-textarea>
      </b-form-group>

      <b-row>
        <b-col cols="12" md="3">
          <b-form-group
            label="Periodicidade (meses)"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-input
              v-model="localForm.verificationPeriodicityMonths"
              type="number"
              min="1"
              max="60"
              class="grc-form-control"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            label="Prazo máximo"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-input
              v-model="localForm.deadline"
              type="date"
              class="grc-form-control"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            label="Implementado em"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-input
              v-model="localForm.implementedAt"
              type="date"
              class="grc-form-control"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            label="Próxima revisão"
            label-class="grc-form__label"
            class="grc-form__group"
          >
            <b-form-input
              v-model="localForm.nextReviewAt"
              type="date"
              class="grc-form-control"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group
        label="Motivo da atualização"
        label-class="grc-form__label"
        class="grc-form__group"
      >
        <b-form-textarea
          v-model.trim="localForm.lastUpdateReason"
          rows="2"
          class="grc-form-control"
        ></b-form-textarea>
      </b-form-group>

      <div class="grc-form__toggle-hint">
        Defina se o requisito permanece disponível para operação e
        acompanhamento.
      </div>
      <b-form-checkbox
        v-model="localForm.active"
        switch
        class="grc-form__toggle"
      >
        Requisito ativo
      </b-form-checkbox>
    </section>

    <div class="grc-form__actions">
      <b-button variant="secondary" @click="$emit('cancel')">Cancelar</b-button>
      <b-button
        type="submit"
        variant="primary"
        :disabled="saving || Boolean(submitValidationError)"
      >
        {{ saving ? "Salvando..." : "Salvar" }}
      </b-button>
    </div>
  </b-form>
</template>

<script>
import SearchableSelect from "@/components/SearchableSelect.vue";

const GRCRequirementStatus = {
  NOT_ATTENDED: 1,
  PARTIALLY_ATTENDED: 2,
  ATTENDED: 3,
  NOT_APPLICABLE: 4,
};

export default {
  name: "GRCRequirementForm",
  components: {
    SearchableSelect,
  },
  props: {
    requirement: {
      type: Object,
      default: null,
    },
    areaOptions: {
      type: Array,
      default: () => [],
    },
    scopeOptions: {
      type: Array,
      default: () => [],
    },
    projectOptions: {
      type: Array,
      default: () => [],
    },
    userOptions: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localForm: this.buildForm(this.requirement),
      statusValues: GRCRequirementStatus,
    };
  },
  computed: {
    approvalLabel() {
      if (!this.requirement?.approval?.status) {
        return null;
      }
      const labels = {
        "not-required": "Sem aprovação obrigatória",
        pending: "Aguardando aprovação",
        approved: "Aprovado",
        rejected: "Rejeitado",
      };
      return (
        labels[this.requirement.approval.status] ||
        this.requirement.approval.status
      );
    },
    statusOptions() {
      const attendedRequirementsMet = Boolean(
        String(this.localForm.title || "").trim() &&
          String(this.localForm.sourceName || "").trim() &&
          String(this.localForm.derivedObligations || "").trim() &&
          String(this.localForm.applicationType || "").trim() &&
          String(this.localForm.criticality || "").trim() &&
          this.localForm.area &&
          this.localForm.verificationPeriodicityMonths &&
          this.localForm.implementedAt
      );

      return [
        this.buildStatusOption(this.statusValues.NOT_ATTENDED, "Não atendido"),
        this.buildStatusOption(
          this.statusValues.PARTIALLY_ATTENDED,
          "Parcialmente atendido"
        ),
        this.buildStatusOption(
          this.statusValues.ATTENDED,
          "Atendido",
          attendedRequirementsMet,
          "Para marcar como atendido, preencha obrigações derivadas, periodicidade e data de implementação."
        ),
        this.buildStatusOption(
          this.statusValues.NOT_APPLICABLE,
          "Não se aplica"
        ),
      ];
    },
    submitValidationError() {
      if (this.localForm.status === this.statusValues.ATTENDED) {
        if (!String(this.localForm.derivedObligations || "").trim()) {
          return "Para salvar como atendido, informe as obrigações derivadas.";
        }
        if (!this.localForm.verificationPeriodicityMonths) {
          return "Para salvar como atendido, informe a periodicidade de verificação.";
        }
        if (!this.localForm.implementedAt) {
          return "Para salvar como atendido, informe a data de implementação.";
        }
      }

      return "";
    },
    sourceTypeOptions() {
      return [
        { value: "legal-regulatory", text: "Legal/Regulatório" },
        { value: "contract", text: "Contrato" },
        { value: "internal-policy", text: "Política interna" },
        { value: "technical-standard", text: "Norma técnica" },
        { value: "best-practice", text: "Boa prática" },
        { value: "judicial-decision", text: "Decisão judicial" },
        { value: "other", text: "Outro" },
      ];
    },
    applicationTypeOptions() {
      return [
        { value: "all", text: "Todos" },
        { value: "sectors", text: "Setores" },
        { value: "stakeholders", text: "Stakeholders" },
        { value: "process", text: "Processo" },
      ];
    },
    criticalityOptions() {
      return [
        { value: "low", text: "Baixa" },
        { value: "medium", text: "Média" },
        { value: "high", text: "Alta" },
        { value: "critical", text: "Crítica" },
      ];
    },
    segregationOptions() {
      return [
        { value: "all", text: "Todos" },
        { value: "outsourced", text: "Terceirizado" },
        { value: "area", text: "Área" },
        { value: "responsible", text: "Responsável" },
        { value: "board", text: "Diretoria" },
        { value: "council", text: "Conselho" },
      ];
    },
    scopeOptionsWithEmpty() {
      return [
        { value: null, text: "Selecione um escopo" },
        ...this.scopeOptions,
      ];
    },
    userOptionsWithEmpty() {
      return [
        { value: null, text: "Selecione um usuário" },
        ...this.userOptions,
      ];
    },
  },
  watch: {
    requirement: {
      immediate: true,
      handler(value) {
        this.localForm = this.buildForm(value);
      },
    },
  },
  methods: {
    buildStatusOption(value, text, enabled = true, disabledHint = "") {
      return {
        value,
        text,
        disabled: !enabled && this.localForm.status !== value,
        ...(disabledHint && !enabled && this.localForm.status !== value
          ? { text: `${text} (${disabledHint})` }
          : {}),
      };
    },
    buildForm(requirement) {
      return {
        title: requirement?.title || "",
        description: requirement?.description || "",
        derivedObligations: requirement?.derivedObligations || "",
        sourceType: requirement?.sourceType || "legal-regulatory",
        sourceName: requirement?.sourceName || "",
        sourceIdentifier: requirement?.sourceIdentifier || "",
        sourceDispositive: requirement?.sourceDispositive || "",
        jurisdiction: requirement?.jurisdiction || "",
        applicationType: requirement?.applicationType || "all",
        applicationDetails: requirement?.applicationDetails || "",
        internalCategory: requirement?.internalCategory || "",
        criticality: requirement?.criticality || "medium",
        area: requirement?.area?._id || requirement?.area || null,
        scope: requirement?.scope?._id || requirement?.scope || null,
        projects: Array.isArray(requirement?.projects)
          ? requirement.projects.map((item) => item._id || item)
          : [],
        owner: requirement?.owner?._id || requirement?.owner || null,
        secondLevelApprover:
          requirement?.secondLevelApprover?._id ||
          requirement?.secondLevelApprover ||
          null,
        manager: requirement?.manager?._id || requirement?.manager || null,
        complianceCriteria: requirement?.complianceCriteria || "",
        segregation: requirement?.segregation || "all",
        verificationPeriodicityMonths:
          requirement?.verificationPeriodicityMonths || "",
        deadline: this.formatDateForInput(requirement?.deadline),
        implementedAt: this.formatDateForInput(requirement?.implementedAt),
        nextReviewAt: this.formatDateForInput(requirement?.nextReviewAt),
        lastUpdateReason: requirement?.lastUpdateReason || "",
        status: requirement?.status || GRCRequirementStatus.NOT_ATTENDED,
        active: requirement?.active !== false,
      };
    },
    formatDateForInput(value) {
      if (!value) {
        return null;
      }
      return new Date(value).toISOString().slice(0, 10);
    },
    normalizeId(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      const parsed = parseInt(value);
      return Number.isNaN(parsed) ? null : parsed;
    },
    submitForm() {
      if (this.submitValidationError) {
        return;
      }

      this.$emit("submit", {
        ...this.localForm,
        area: this.normalizeId(this.localForm.area),
        scope: this.normalizeId(this.localForm.scope),
        projects: (this.localForm.projects || [])
          .map((item) => this.normalizeId(item))
          .filter(Boolean),
        owner: this.normalizeId(this.localForm.owner),
        secondLevelApprover: this.normalizeId(
          this.localForm.secondLevelApprover
        ),
        manager: this.normalizeId(this.localForm.manager),
        verificationPeriodicityMonths: this.localForm
          .verificationPeriodicityMonths
          ? parseInt(this.localForm.verificationPeriodicityMonths)
          : null,
        status: parseInt(this.localForm.status),
        deadline: this.localForm.deadline || null,
        implementedAt: this.localForm.implementedAt || null,
        nextReviewAt: this.localForm.nextReviewAt || null,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use "./grc-form.scss";
</style>
